export default __webpack_public_path__ + "static/media/AntyLucy_20.21954294.jpg";